import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../Icon/index.js";
import { responsivePropDependency } from "../../utilities/props.js";
import IconArrow from "../../icons/ChevronVertical.js";
import s from "./Select.module.css";
const SelectEndContent = (props) => {
    const { disabled, size } = props;
    return (_jsx("div", { className: s.arrow, children: _jsx(Icon, { svg: IconArrow, color: disabled ? "disabled" : "neutral-faded", size: responsivePropDependency(size, (size) => {
                return size === "large" || size === "xlarge" ? 5 : 4;
            }) }) }));
};
export default SelectEndContent;
